export const DisableAllInclusiveIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className='m-1.5'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <path
        d='M3.29297 7.36426C2.29424 7.82246 1.59961 8.82941 1.59961 10C1.59961 11.6016 2.89837 12.9004 4.5 12.9004C5.67076 12.9004 6.67665 12.205 7.13477 11.2061L8.31445 12.3857C7.51883 13.6551 6.10863 14.5 4.5 14.5C2.01472 14.5 0 12.4853 0 10C0 8.39148 0.844031 6.98022 2.11328 6.18457L3.29297 7.36426ZM15.5 5.5C17.9853 5.5 20 7.51472 20 10C20 11.5288 19.2366 12.8782 18.0713 13.6914C18.0332 13.6321 17.9893 13.5753 17.9375 13.5234L16.9326 12.5186C17.8083 12.0193 18.4004 11.0799 18.4004 10C18.4004 8.39837 17.1016 7.09961 15.5 7.09961C14.4202 7.09961 13.4798 7.69092 12.9805 8.56641L11.8223 7.4082C12.637 6.25425 13.98 5.5 15.5 5.5Z'
        fill={'var(--mui-palette-custom-BLACK-01)'}
      />
      <rect
        x='2.14453'
        y='0.730469'
        width='22.8042'
        height='1.6'
        rx='0.5'
        transform='rotate(45 2.14453 0.730469)'
        fill={'var(--mui-palette-custom-BLACK-01)'}
      />
    </svg>
  );
};
